import Vue from 'vue';

export function notify(message, type = "default", options = {}) {
    Vue.$toast.open({
        message,
        type: type,
        duration: 3000,
        position: 'bottom',
        ...options,
    });
}

export const loader = (status) => {
  let loader = document.querySelector('#loader');
  let loaderNode = document.createElement('div');
  loaderNode.classList.add('page-loading');
  loaderNode.setAttribute('id', 'loader');
  loaderNode.innerHTML = '<div class="loader">Loading...</div>';

  loader && loader.remove();
  if(status){
    document.body.appendChild(loaderNode);
  }
}

export const queryParams = (name = null) => {
  const params = new URLSearchParams(window.location.search);
  const query = {};

  if(name){
    return { [name]: params.get(name) };
  }

  for (const [key, value] of params.entries()) {
    query = {...query, [key]: value }

  }
  return query;
}

export const disabledOnBeforeUnload = () => {
  window.onbeforeunload = function() {
    return null;
  }
}
